export const ADD_WALLET = 'ADD_WALLET';

export const addWallet = data => ({
  type: ADD_WALLET,
  data 
});



